import focusElement from "./focus-element";

/**
 * 聚焦自定义积木的名称
 * @param args
 */
export default function focusCustomProcedureName(args) {
    return focusElement({element: ".blocklyHtmlInput", pointerEvents: 'none', ...args});
}
